<template>
  <div class="js-collapse accordion__item">
    <button type="button" class="js-collapse-button accordion__header" :class="{ caption: dense === true }">
      <div class="grid grid--jcStart grid--row grid--inline">
        <div class="grid grid--row grid--aiCenter grid--jcStart">
          <icon-calendar></icon-calendar>
          <p>{{ day | dayToLabel }}</p>
        </div>
        <div class="grid grid--row grid--aiCenter grid--jcStart">
          <icon-clock></icon-clock>
          <p class="text--regular">{{ slot }}</p>
        </div>
        <template v-if="dense !== true">
          <p class="text--regular text-right">£{{ price | setDecimals }}</p>
        </template>
      </div>
    </button>
    <div class="js-collapse-content accordion__content text--regular" :class="dense === true ? 'overline' : 'caption'">
      <template v-for="product in products">
        <div class="grid grid--jcSpaceBetween" v-if="product.qty > 0" :key="product.id">
          <p>{{ product.name }} x {{ product.qty }}</p>
          <template v-if="dense !== true">
            <p>£{{ product.price * product.qty | setDecimals }}</p>
          </template>
        </div>
      </template>
      <template v-if="dense !== true">
        <div class="grid grid--jcSpaceBetween">
          <p>Delivery</p>
          <p>£{{ (config.delivery_price / 100) | setDecimals }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ['day', 'slot', 'products', 'dense'],

  data() {
    return {
      price: 0
    }
  },

  beforeMount() {
    this.price = 0;

    // If come from database, quick fix
    $.each(this.$props.products, (index, product) => {
      if (product.product) {
        var qty = product.qty;
        this.$props.products[index] = product.product;
        this.$props.products[index].qty = qty;
      }
    });

    $.each(this.$props.products, (index, product) => {
      this.price += parseFloat(product.price) * parseFloat(product.qty);
    });

    this.price += parseFloat(this.config.delivery_price / 100);
  },

  beforeUpdate() {
    // If come from database, quick fix
    $.each(this.$props.products, (index, product) => {
      if (product.product) {
        var qty = product.qty;
        this.$props.products[index] = product.product;
        this.$props.products[index].qty = qty;
      }
    });
  },

  mounted() {
  },

  methods: {},

  computed: {
    config() {
      return window.config;
    }
  }
}
</script>
